import type { PrimeVuePTOptions } from 'primevue/config';

export default {
  root: {
    class: 'max-w-72 w-full !right-20',
  },
} satisfies PrimeVuePTOptions['toast'];
